/**
 * @overview 课程编辑
 * @author 3173
 * @date 2019-1-20
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer, WizAvatarUpload, modelUtils, ossFileUtils } = framework_tool;
let { Wizmessage, WizForm, WizButton, WizModal, WizIcon, WizDropdown, WizMenu, WizTable, WizCustomSteps, WizAntdForm, WizBraftEditor } = component_tool;
let { Session } = utils_tool;
import DateSelect from './dateSelect'
import ProgramLimit from './programLimit'
import { Spin, Card, Row, Col, Divider } from 'antd'
import '../../../../styles/containers/online/programDetail/index.less'
import cx from 'classnames';
import ScheduleList from "./listSelect/scheduleList";
import ExamList from "./listSelect/examList";
import { WizTableForm, WizClassifySelectRe as ClassifySelect, WizBraftEditorPlus } from '@/containers/common'
import ProgramAuthSelect from '../programAuth/programAuthSelect'
import moment from "moment";

const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole" } })
const WizItem = WizMenu.Item

const steps = [
  {
    title: '课程信息',
    content: 'First-content',
  },
  {
    title: '课程内容',
    content: 'Second-content',
  },
  {
    title: '受众设置',
    content: 'Last-content',
  },
];
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};

class ProgramDetail extends WizContainer {

  componentName = 'ProgramDetail';

  constructor(props) {
    super(props);
    this.state = {
      codeVisible: false,
      programVisible: false,
      scheduleModalVisible: false,//课件选择
      examModalVisible: false,//考试选择
      examCount: 0,
      scheduleCount: 0,
      scheduleMinute: 0,
      current: 0,
      programId: null,//课程id 第二步必须要用到
      programContent: [],
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
      editorContent: '',
      editorValue: '',
      auth: {
        orgIds: [],
        positionIds: [],
        positionCategoryIds: [],
        personIds: []
      }, //受众权限
      examListModalKey: 'examListModal',
      scheduleListModalKey: 'scheduleListModal',
      startDate: "",
      endDate: "",

    }
    this.nextStepState = false;
    this.initialValue = { id: null };
    this.status = 0;//课程状态
    this.clearWizCallBack = [];
  }

  _componentWillMount() {

    const { history } = this.props;
    if (history.location && history.location.pathname === '/program/programList/programDetailUpd') {
      if (history.location.record) {
        Session.set('programRecord', history.location.record);
        this.initialValue = this.arrangeRecord(history.location.record);
        this.setState({
          programId: this.initialValue.id,
          editorContent: WizBraftEditor.createEditorState(this.initialValue.intro ? this.initialValue.intro : null),
          editorValue: WizBraftEditor.createEditorState(this.initialValue.intro ? this.initialValue.intro : null),
          startDate: this.initialValue && this.initialValue.startDate ? this.initialValue.startDate : "",
          endDate: this.initialValue && this.initialValue.endDate ? this.initialValue.endDate : "",
        })
      } else if (Session.get('programRecord')) {
        this.initialValue = Session.get('programRecord') ? this.arrangeRecord(Session.get('programRecord')) : {};
        this.setState({
          programId: this.initialValue.id,
          editorContent: WizBraftEditor.createEditorState(this.initialValue.intro ? this.initialValue.intro : null),
          editorValue: WizBraftEditor.createEditorState(this.initialValue.intro ? this.initialValue.intro : null),
          startDate: this.initialValue && this.initialValue.startDate ? this.initialValue.startDate : "",
          endDate: this.initialValue && this.initialValue.endDate ? this.initialValue.endDate : "",
        })
      }

    }
  }

  _componentDidMount() {

    if (this.initialValue && this.initialValue.lectureIds) {
      this.getPersonInfoByPersonIdList()
    }
    this.doActions([
      {
        path: `questionType/nodeList`,
        payload: {
          key: `questionType@treeData`,
          apiParams: { type: 1, state: 1 }
        }
      }
    ])
  }

  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectureIds,
        }
      }
    });
  }

  /**获取课程数据 */
  getProgramById() {
    this.doAction({
      path: 'program/getProgramById',
      payload: {
        key: 'getProgramById',
        apiParams: {
          id: this.state.programId,
        }
      }
    });
  }

  /**行数据处理 */
  arrangeRecord(record) {
    let data = record;
    if (data.imgOne == -1) {
      data.imgOne = null;
    }
    data.date = {
      startDate: record.startDate,
      endDate: record.endDate
    }
    data.limit = {
      limitOrder: record.limitOrder,
      preCondition: record.preConditionId && record.preCondition ? record.preCondition : undefined,
      preConditionId: record.preConditionId
    }
    if (record.shareWays) {
      let ways = record.shareWays.split(",");
      for (let i = 0; i < ways.length; i++) {
        if (ways[i] == '0') {
          data.shareWay_wechat = [1]
        } else if (ways[i] == '1') {
          data.shareWay_community = [1]
        }
      }
    }
    //拼接分类
    if (data.programCategoryNames && data.programCategoryIds) {
      let programCategory = [];
      let cNames = data.programCategoryNames.split(",");
      let cIds = data.programCategoryIds.split(",");
      if (cNames.length === cIds.length) {
        for (let i = 0; i < cNames.length; i++) {
          programCategory.push({ title: cNames[i], key: cIds[i] })
        }
        data.programCategory = programCategory;
        data.programCategoryIds = cIds;
      }
    }
    //讲师
    if (data.lectureIds) {
      let lectures = data.lectureIds.split(",");
      data.lectures = lectures;
    }

    return data;
  }

  propsAndStateOnChange = {
    addProgram: this._stepOne.bind(this),
    saveProgram: this._stepOneSave.bind(this),
    saveContent: this._stepTwo.bind(this),
    getProgramEntityList: this._getContentOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
    authInfo: this._authInfo.bind(this),
    saveAuthKey: this._saveAuthKey.bind(this),
    programInfo: this._getProgramOver.bind(this)
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addProgram.code == 1) {
      wizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.programId = nextProps.addProgram.data.id;
        this.initialValue.id = nextProps.addProgram.data.id;
      } else {
        this.jumpPage('replace', '/program/programList');
      }
    } else {
      this.nextStepState = false;
      wizNotice.error('保存失败：' + nextProps.addProgram.msg);
    }
    return true;
  }

  _stepOneSave(nextProps, nextState) {
    if (nextProps.saveProgram.code == 1) {
      wizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        this.getProgramContent();
      } else {
        this.jumpPage('replace', '/program/programList');
      }
    } else {
      this.nextStepState = false;
      wizNotice.error('保存失败：' + nextProps.saveProgram.msg);
    }
    return true;
  }

  _stepTwo(nextProps, nextState) {
    if (nextProps.saveContent.code == 1) {
      wizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        // this.jumpPage(
        //   'push',
        //   '/program/programList/programAuth',
        //   { id: this.state.programId }
        // )
        this.getProgramAuthInfo();
      } else {
        this.jumpPage('replace', '/program/programList');
      }
    } else {
      this.nextStepState = false;
      wizNotice.error('保存失败：' + nextProps.saveContent.msg);
    }
    return true;
  }

  _getContentOver(nextProps, nextState) {
    if (nextProps.getProgramEntityList.code == 1) {
      nextState.programContent = nextProps.getProgramEntityList.data;
      if (nextProps.getProgramEntityList.data && nextProps.getProgramEntityList.data instanceof Array) {
        let scheduleCount = 0;
        let scheduleMinute = 0;
        let examCount = 0;
        nextProps.getProgramEntityList.data.forEach(data => {
          if (data.type == 1) {
            examCount++;
          } else if (data.type == 0) {
            scheduleCount++;
            scheduleMinute += data.duration && parseInt(data.duration) >= 0 ? parseInt(data.duration) : 0;
          }
        })
        nextState.scheduleCount = scheduleCount;
        nextState.scheduleMinute = scheduleMinute;
        nextState.examCount = examCount;
      }

    }
    return true;
  }

  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      this.initialValue.personInfo = personInfo;
    }
    return true;
  }

  _saveAuthKey(nextProps, nextState) {
    let { saveAuthKey } = nextProps
    if (saveAuthKey && (saveAuthKey['success'] || saveAuthKey['code'] == 1)) {
      let authUpd = saveAuthKey["data"]
      if (authUpd) {
        if (authUpd > 0) {
          WizModal.confirm({
            title: '注意', content: "消息通知内容有变更，是否重新发送消息通知", cancelText: "否", okText: "是",
            onOk: () => {
              this.doActions([
                {
                  path: "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: this.initialValue.id,
                      bizType: 0,
                      resend: true
                    },
                  },
                },
              ]);

              this.jumpPage('push', '/program/programList');
            },
            onCancel: () => {
              this.doActions([
                {
                  path: "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: this.initialValue.id,
                      bizType: 0,
                      resend: false
                    },
                  },
                },
              ]);
              this.jumpPage('push', '/program/programList');
            }
          });
        } else {

          this.doActions([
            {
              path: "notice/sendNotice",
              payload: {
                key: "sendNoticeKey",
                apiParams: {
                  bizId: this.initialValue.id,
                  bizType: 0,
                  resend: false
                },
              },
            },
          ]);
          this.jumpPage('push', '/program/programList');
        }
      } else {

        this.jumpPage('push', '/program/programList');
      }
      return true
    } else {
      wizNotice.error(saveAuthKey && saveAuthKey['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps
    if (authInfo && authInfo['success']) {
      nextState.auth = authInfo['data']
    }
    return false
  }

  _getProgramOver(nextProps, nextState) {
    let { programInfo } = nextProps

    if (programInfo && programInfo['success']) {
      this.initialValue = this.arrangeRecord(programInfo['data'])
      nextState.current = this.state.current - 1

    }
    return true
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      // if (value != null && value != undefined) {
      //   fitterValues[key] = value;
      // }
      if (key === 'date' && value != null && value != undefined) {
        fitterValues['date'] = {};
        fitterValues['date']['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
        fitterValues['date']['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    if (fitterValues && fitterValues['imgOne'] && fitterValues['imgOne'].length) {
      fitterValues.imgOne = fitterValues.imgOne[0].fileId;//imgOne获取对应上传实体的fileId
    } else {
      fitterValues.imgOne = "";
    }
    // let {editorValue} = this.state
    // if (editorValue) {
    //   fitterValues['intro'] = editorValue;
    // }
    return fitterValues;
  }


  /**保存 */
  _saveProgram(values) {
    const { history } = this.props;
    let apiPath = "program/add";
    let actionKey = 'addProgram';
    if ((history.location && history.location.pathname === '/program/programList/programDetailUpd') || this.state.programId) {
      apiPath = "program/update";
      actionKey = 'saveProgram';
    }
    let fitterValues = this.fitterFieldsValue(values)
    let shareWays = null;
    if (fitterValues.shareWay_wechat && fitterValues.shareWay_wechat.length > 0 && fitterValues.shareWay_community && fitterValues.shareWay_community.length > 0) {
      shareWays = '0,1'
    } else if (fitterValues.shareWay_community && fitterValues.shareWay_community.length > 0) {
      shareWays = '1'
    } else if (fitterValues.shareWay_wechat && fitterValues.shareWay_wechat.length > 0) {
      shareWays = '0'
    }
    if (fitterValues.lectures && fitterValues.lectures instanceof Array) {
      let lectureIds = '';
      fitterValues.lectures.forEach(data => {
        lectureIds += data + ',';
      })
      if (lectureIds.length > 0) {
        lectureIds = lectureIds.substring(0, lectureIds.length - 1);
        fitterValues.lectureIds = lectureIds;
      }
    }
    if (fitterValues.date.endDate && !fitterValues.date.endDate.getTime) {
      fitterValues.date.endDate = new Date(fitterValues.date.endDate);
    }
    if (fitterValues.date.startDate && !fitterValues.date.startDate.getTime) {
      fitterValues.date.startDate = new Date(fitterValues.date.startDate);
    }
    //this.initialValue = {...this.initialValue,...fitterValues}
    this.doAction({
      path: apiPath,
      payload: {
        key: actionKey,
        apiParams: {
          duration: this.initialValue.duration ? this.initialValue.duration : 0,
          status: this.initialValue.status ? this.initialValue.status : 0,
          endDate: fitterValues.date.endDate.getTime(),
          startDate: fitterValues.date.startDate.getTime(),
          limitOrder: fitterValues.limit.limitOrder,
          shareWays: shareWays,
          ...fitterValues,
        }
      }
    });

  }

  /**保存课程内容 */
  saveProgramContent(nextStep) {
    if (nextStep) {
      this.nextStepState = true;
    }
    this.doAction({
      path: 'programEntity/batchSave',
      payload: {
        key: 'saveContent',
        apiParams: {
          programId: this.state.programId,
          list: this.state.programContent
        }
      }
    });
  }

  /**获取课程内容 */
  getProgramContent() {
    this.doAction({
      path: 'programEntity/getListByProgramId',
      payload: {
        key: 'getProgramEntityList',
        apiParams: {
          programId: this.state.programId,
        }
      }
    });
  }

  /**获取课程受众 */
  getProgramAuthInfo() {
    this.doAction({
      path: 'program/authInfo',
      payload: {
        key: 'programAuthInfo',
        apiParams: {
          id: this.state.programId,
        }
      }
    });
  }


  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  /**上一步 */
  previousStep(getInfo) {
    if (getInfo) {
      this.getProgramById();
    } else {
      this.setState({
        current: this.state.current - 1
      })
    }
  }


  /**选择课件模态框 */
  scheduleListModal() {
    return (
      <WizModal
        visible={this.state.scheduleModalVisible}
        onCancel={() => this.setState({ scheduleModalVisible: false })}
        onOk={() => this.pushProgramContent('schedule')}
        style={{ minWidth: 1000 }}
        title={'选择课件'}
        key={this.state.scheduleListModalKey}
      >
        <ScheduleList exists={this.state.programContent} handleClear={id => this.handleClear(id, 'selectedScheduleRows')} selectedRows={this.state.selectedScheduleRows} updateRows={(rows) => this.selectRows(rows, 'selectedScheduleRows', 'name')} />
      </WizModal>
    )
  }

  /**选择课程考试模态框 */
  examListModal() {
    return (
      <WizModal
        visible={this.state.examModalVisible}
        onCancel={() => this.setState({ examModalVisible: false })}
        onOk={() => this.pushProgramContent('exam')}
        style={{ minWidth: 1000 }}
        title={'选择考试'}
        key={this.state.examListModalKey}
      >
        <ExamList exists={this.state.programContent} categoryType={'课程考试'} handleClear={id => this.handleClear(id, 'selectedExamRows')} selectedRows={this.state.selectedExamRows} updateRows={(rows) => this.selectRows(rows, 'selectedExamRows', 'title')} />
      </WizModal>
    )
  }

  handleClear(id, key) {
    id
      ? this.setState({
        [key]: this.state[key].filter(item => item.id !== id)
      })
      : this.setState({
        [key]: []
      });
  }

  /**将选择的数据添加至state中 */
  selectRows(rows, key, name) {
    let list = [];
    rows && rows.forEach(row => {
      //row.userName = row[name];
      list.push(row);
    });

    this.setState({
      rowData: new Date().getTime(),
      [key]: list
    });
  }

  /**将选择的数据转换成页面能显示的数据 */
  pushProgramContent(type) {
    let programContent = Object.assign([], this.state.programContent);
    let addIndex = programContent.length
    let examAddCount = this.state.selectedExamRows.length;//考试增加的数量
    let scheduleAddCount = this.state.selectedScheduleRows.length;//课件增加的数量
    let addMinute = 0;//课件增加的时长
    if (type === 'exam') {//考试部分数据
      this.state.selectedExamRows.forEach(exam => {
        addIndex++;
        let content = {
          entityId: exam.id,
          orderNum: addIndex,
          type: 1,
          state: 1,
          typeStr: '考试',
          programId: this.state.programId,
          title: exam.title,
          endDate: exam.endDate
        }
        programContent.push(content)
      })
    } else if (type === 'schedule') {//课件部分数据
      this.state.selectedScheduleRows.forEach(schedule => {
        addIndex++;
        addMinute += schedule.duration;
        let content = {
          entityId: schedule.id,
          orderNum: addIndex,
          type: 0,
          state: 1,
          typeStr: '课件',
          programId: this.state.programId,
          title: schedule.name,
          endDate: schedule.endTime,
          code: schedule.code,
          duration: schedule.duration,
          mode: schedule.typeName,
          supports: schedule.supportsName
        }
        programContent.push(content)
      })
    }

    this.setState({
      programContent: programContent,
      examModalVisible: false,
      scheduleModalVisible: false,
      selectedExamRows: [],
      selectedScheduleRows: [],
      examCount: this.state.examCount + examAddCount,
      scheduleCount: this.state.scheduleCount + scheduleAddCount,
      scheduleMinute: this.state.scheduleMinute + addMinute,
      examListModalKey: 'examListModal' + new Date().getTime(),
      scheduleListModalKey: 'scheduleListModal' + new Date().getTime()
    })

  }

  /**行删除 */
  deleteRow(record) {
    const { programContent, examCount, scheduleCount, scheduleMinute } = this.state;
    let examCount_ = examCount;
    let scheduleCount_ = scheduleCount;
    let scheduleMinute_ = scheduleMinute;
    let neoProgramContent = Object.assign([])
    for (let i = 0; i < programContent.length; i++) {
      if (programContent[i].orderNum != record.orderNum) {
        let entity = programContent[i]
        entity.orderNum = neoProgramContent.length + 1
        neoProgramContent.push(entity)
      } else {
        if (programContent[i].type == 1) {
          examCount_--;
        } else if (programContent[i].type == 0) {
          scheduleCount_--;
          scheduleMinute_ -= programContent[i].duration && parseInt(programContent[i].duration) >= 0 ? parseInt(programContent[i].duration) : 0;
        }
      }
    }
    this.setState({
      programContent: neoProgramContent,
      time: new Date().getTime(),
      examCount: examCount_,
      scheduleCount: scheduleCount_,
      scheduleMinute: scheduleMinute_
    })
  }

  /**上移下移 行数据 */
  moveUpAndDown(record) {
    const { programContent } = this.state;
    if (programContent.length > 1) {
      let oldOrderNum = record.orderNum;
      let neoProgramContent = Object.assign([])
      for (let i = 0; i < programContent.length; i++) {
        let entity = programContent[i]
        if (oldOrderNum == 1) { //首位下移
          if (i == 0) {
            entity.orderNum = 2;
          } else if (i == 1) {
            entity.orderNum = 1;
          }
        } else { //上移
          if (oldOrderNum == (i + 1)) {
            entity.orderNum = i;
          } else if (oldOrderNum == (i + 2)) {
            entity.orderNum = i + 2;
          }
        }
        neoProgramContent.push(entity)
      }
      //重新排序
      neoProgramContent.sort(function (a, b) {
        if (a['orderNum'] < b['orderNum']) {
          return -1
        }
        if (a['orderNum'] > b['orderNum']) {
          return 1
        }
        return 0;
      });
      this.setState({
        programContent: neoProgramContent,
        time: new Date().getTime()
      })
    }
  }

  /**修改状态 行数据 */
  changeState(record) {
    const { programContent } = this.state;
    if (programContent.length) {
      let oldState = record.state;
      let neoProgramContent = Object.assign([])
      for (let i = 0; i < programContent.length; i++) {
        let entity = programContent[i]
        if ((entity.id != null && entity.id != undefined && entity.id === record.id) || (entity.type === record.type && entity.entityId === record.entityId)) {
          if (oldState === undefined || oldState == null || oldState === -1 || oldState === 1) {
            entity.state = 0;
          } else {
            entity.state = 1;
          }
        }
        neoProgramContent.push(entity)
      }
      //重新排序
      neoProgramContent.sort(function (a, b) {
        if (a['orderNum'] < b['orderNum']) {
          return -1
        }
        if (a['orderNum'] > b['orderNum']) {
          return 1
        }
        return 0;
      });
      this.setState({
        programContent: neoProgramContent,
        time: new Date().getTime()
      })
    }
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <Row className="form-btns-step1" >
        <Col span={24}>

          <WizButton title="保存并进入下一步" type="primary" htmlType="submit" onClick={e => this.nextStep()}  >保存并进入下一步</WizButton>
          <WizButton title="保存并返回" type="primary" htmlType="submit" >保存并返回</WizButton>
          <WizButton title="重置" type="primary" onClick={e => this.onReset()}>重置</WizButton>
        </Col>
      </Row>
    )
  }

  /**课程编码展示图片 */
  codeModal() {
    return (
      <WizModal
        visible={this.state.codeVisible}
        title={'课程编码规则'}
        width={600}
        footer={null}
        onCancel={() => this.setState({ codeVisible: false })}
      >
        {/* <div className="code-rule">课程编码示例: B_CP_S_WBT_201302_V1</div> */}
        <img width="550px" height="320px" src={constants.files.sys_program_code_rule} alt="课程编码图片" />
      </WizModal>
    )
  }

  /**表单重置 */
  onReset = e => {
    let ref = this.refs.form
    if (ref) {
      ref.resetFields()
    }

    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  handleMenuClick(e) {
    if (e.key === 'programAdd') {
      this.setState({ scheduleModalVisible: true })
    } else if (e.key === 'examAdd') {
      this.setState({ examModalVisible: true })
    }
  }

  /**选择课程内容 */
  programContent() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key="programAdd">
          课件
        </WizItem>
        <WizItem key="examAdd">
          考试
        </WizItem>
      </WizMenu>
    );

    const columns = [
      {
        title: '类型',
        dataIndex: 'typeStr',
        key: 'typeStr',
        width: 60
      },
      {
        title: '名称',
        dataIndex: 'title',
        key: 'title',
        width: 120,
        ellipsis: true,
      },
      {
        title: '编号',
        dataIndex: 'code',
        key: 'code',
        width: 80
      },
      {
        title: '有效截止时间',
        dataIndex: 'time',
        key: 'time',
        render: (text, record) => (
          <>{record && record.time ? formatterDate(moment(record.time + ':00')) : ''}</>
        ),
        width: 100
      },
      {
        title: '文件格式',
        dataIndex: 'mode',
        key: 'mode',
        width: 80
      },
      {
        title: '支持平台',
        dataIndex: 'supports',
        key: 'supports',
        width: 80
      },
      {
        title: '学习时长',
        dataIndex: 'duration',
        key: 'duration',
        width: 80
      },
      {
        title: '是否需要完成',
        dataIndex: 'state',
        key: 'state',
        width: 100,
        render: (text, record) => (
          <>{record && record.state != null && record.state === 0 ? '否' : '是'}</>
        ),
      },
      {
        title: '排序',
        dataIndex: 'orderNum',
        key: 'orderNum',
        width: 60
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a onClick={e => this.changeState(record)}> {record.state != null && record.state == 0 ? '需要' : '无需'}完成</a>
            <Divider type="vertical" />
            <a onClick={e => this.moveUpAndDown(record)}> {record.orderNum == 1 ? '下' : '上'}移</a>
            <Divider type="vertical" />
            <a onClick={e => this.deleteRow(record)}>删除</a>
          </span>
        ),
      },
    ];

    let rowSelection = {
      getCheckboxProps: record => ({
        type: record.type == 0 ? '课件' : '考试',
      }),
    }

    return (
      <div className="table-div">

        <WizDropdown overlay={menu}>
          <WizButton type="primary">
            新增课程内容 <WizIcon type="down" />
          </WizButton>
        </WizDropdown>

        <div className="table-row" key={'program_content_' + this.state.time}>
          <WizTable pagination={false} columns={columns} dataSource={this.state.programContent} />
        </div>
        <div className="table-row">
          <div className="outline-font">课程概要 </div>
        </div>
        <div className="div-outline">
          {this.outlineView(this.state.scheduleCount, '总课件数', { color: '#3D80E3' })}
          <span className="separator" />
          {this.outlineView(this.state.scheduleMinute, '总时长(分)', { color: '#3DE3D5' })}
          <span className="separator" />
          {this.outlineView(this.state.examCount, '总考试数', { color: '#E3773D' })}
        </div>
        <div className="form-btns row-item table-row" >
          <Row className="form-btns-step1" >
            <Col span={24}>
              <WizButton title="上一步" type="primary" onClick={e => this.previousStep(true)}  >上一步</WizButton>
              <WizButton title="下一步" type="primary" onClick={e => this.saveProgramContent('nextStep')}  >保存并进入下一步</WizButton>
              <WizButton title="保存" type="primary" onClick={e => this.saveProgramContent()}  >保存并返回</WizButton>
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  /**概要内容 */
  outlineView(count, title, countColor) {
    return (
      <span className="outline-view">
        <div className="outline-count" style={countColor}>{count}</div>
        <div className="outline-title">{title}</div>
      </span>
    )
  }


  /**根据步骤r展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      return <WizForm key={'form-step'} className={'form-inline'} {...formProps} />
    } else if (this.state.current == 1) {
      return this.programContent();
    } else if (this.state.current == 2) {
      const selectProps = {
        title: '受众设置',
        id: this.state.programId,
        initialValue: this.state.auth,
        submit: this.saveAuth.bind(this),
        prev: this.previousStep.bind(this)
      };
      return <ProgramAuthSelect {...selectProps} />
    } else {
      return null;
    }
  }

  /**保存受众 */
  saveAuth(value) {
    let saveRequest = {}
    if (value['dataAuth']) {
      let dataAuth = value['dataAuth']

      // saveRequest['orgIds'] = dataAuth['orgIds'].map(p => (p.id))
      // saveRequest['positionIds'] = dataAuth['positionIds'].map(p => (p.id))
      // saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'].map(p => (p.id))
      // saveRequest['personIds'] = dataAuth['personIds'].map(p => (p['id']))

      if (dataAuth["groupId"] && dataAuth["groupId"].length) {
        saveRequest["groupId"] = dataAuth["groupId"].map((p) => p["id"]).toString();
      } else {
        saveRequest["orgIds"] = dataAuth["orgIds"] && dataAuth["orgIds"].map((p) => p["id"]);
        saveRequest["positionIds"] = dataAuth["positionIds"] && dataAuth["positionIds"].map((p) => p["id"]);
        saveRequest["positionCategoryIds"] = dataAuth["positionCategoryIds"] && dataAuth["positionCategoryIds"].map((p) => p["id"]);
        saveRequest["personIds"] = dataAuth["personIds"] && dataAuth["personIds"].map((p) => p["id"]);
      }
    }
    saveRequest['id'] = this.state.programId

    this.doAction({
      path: 'program/saveAuth',
      payload: {
        key: "programSaveAuthKey",
        apiParams: {
          ...saveRequest
        }
      }
    });
  }

  /**讲师验证 */
  lecturesValidator = (rule, value, callback) => {
    //const { getFieldValue } = this.props.form; //可以获取form其他的值getFieldValue('a')
    if (value && value.length > 10) {
      callback('讲师最多选择10个')
    }
    // 必须总是返回一个 callback，否则 validateFields 无法响应
    callback();
  }

  /**去前后空格 */
  trimValue = (value) => {
    return value.trim()
  }

  handleChange = (editorContent) => {
    this.setState({
      editorContent: editorContent,
      editorValue: editorContent
    })
  }

  _render() {
    const { history, programLoading, programEntityLoading } = this.props;
    let initialValue = this.initialValue
    let { intro, startDate, endDate } = this.initialValue
    let initialDate = [];
    if (startDate && endDate) {
      initialDate.push(startDate);
      initialDate.push(endDate);
    }
    console.log(initialValue, 'initialValueinitialValueinitialValue')
    let columns = [
      {
        name: "id",
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        }
      },
      {
        title: "课程名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 50,
          placeholder: '课程名称最多输入50个字',
          rules: [{
            required: true,
            whitespace: true,
            message: '请输入课程名称',
          },
          {
            //transform: this.trimValue,
            max: 50,
            message: '课程名称最多输入50个字',
          },
            // {
            //   pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5《》()]{1,20}$/,
            //   message: '课程名称不允许使用特殊符号'
            // }
          ],

          initialValue: initialValue.name
        },
      },
      {
        title: "课程编码",
        name: "scoId",
        dataIndex: "scoId",
        formItem: {
          maxlength: 35,
          placeholder: '请按照编码规则输入',
          suffix: <a onClick={() => this.setState({ codeVisible: true })}>查看编码规则</a>,
          rules: [{
            required: true,
            whitespace: true,
            message: '请输入课程编码',
          },
            // {
            //   transform: this.trimValue,
            //   //pattern: /^[A-Z][_][A-Z]{2}[_][A-Z][_][A-Z]{2,3}[_][\d]{6}[_][V][1-9]$/,
            //   pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5—]{1,35}$/,
            //   message: '请按照编码规则输入'
            // }
          ],
          initialValue: initialValue.scoId
        },
      },
      {
        title: "品牌",
        name: "brand",
        dataIndex: "brand",
        formItem: {
          type: 'select',
          dict: [
            { code: 0, codeName: "别克" },
            { code: 1, codeName: "雪佛兰" },
            { code: 2, codeName: "凯迪拉克" },
            { code: 9, codeName: "跨品牌" },
          ],
          rules: [{
            required: true,
            message: '请选择',
          }],
          initialValue: initialValue.brand,
        },
      },
      {
        title: "功能块",
        name: "module",
        dataIndex: "module",
        formItem: {
          type: 'select',
          dict: [
            { code: 0, codeName: "销售" },
            { code: 1, codeName: "售后服务" },
            { code: 2, codeName: "售后技术" },
            { code: 3, codeName: "诚新二手车" },
            { code: 4, codeName: "校企合作" },
            { code: 5, codeName: "集团销售" },
            { code: 9, codeName: "跨业务块" },
          ],
          rules: [{
            required: true,
            message: '请选择',
          }],
          initialValue: initialValue.module,
        },
      },
      {
        title: "课程来源",
        name: "programSource",
        dataIndex: "programSource",
        formItem: {
          type: 'select',
          dict: [
            { code: 1, codeName: "别克销售" },
            { code: 2, codeName: "雪佛兰销售" },
            { code: 3, codeName: "凯迪拉克销售" },
            { code: 4, codeName: "售后技术" },
            { code: 5, codeName: "售后非技术" },
            { code: 6, codeName: "二手车" },
            { code: 8, codeName: "集团销售" },
            { code: 9, codeName: "校企合作" },
            { code: 10, codeName: "融入辅导_相达" },
            { code: 11, codeName: "融入辅导_申先" },
            { code: 12, codeName: "TAC技术支持" },
            { code: 13, codeName: "其它" },
            { code: 14, codeName: "车工坊" },
            { code: 15, codeName: "德科" },
          ],
          rules: [],
          initialValue: initialValue.programSource,
        },
      },
      {
        title: "课程分类",
        name: "programCategoryIds",
        dataIndex: "programCategoryIds",
        formItem: {

          type: 'diy',
          //form:self.ref.form,
          diy: ClassifySelect,
          returnKey: true,
          wizTreeSelectListProps: {
            itemProps: {
              icon: 'unordered-list',
              title: '课程分类',
              tips: '请勾选所属课程分类'
            },
            treeProps: { checkStrictly: true }
          },
          apiProps: { type: 1 },
          selectProps: {
            placeholder: '请选择课程分类'
          },
          rules: [
            {
              type: 'array'
            },
            {
              required: true,
              message: '请选择课程分类',
            }
          ],
          initialValue: initialValue.programCategoryIds ? initialValue.programCategoryIds : [],
          initSelects: initialValue.programCategory ? initialValue.programCategory : [],
          onClearWiz: this._onClearWiz.bind(this)
        },
      },
      // {
      //   title: "课程时间",
      //   name: "date",
      //   dataIndex: "date",
      //   formItem: {
      //     type: 'diy',
      //     diy: DateSelect,
      //     rules: [
      //       {
      //         required: true,
      //         message: '请选择课程时间',
      //       }
      //     ],
      //     initialValue: initialValue.date
      //   },
      // },
      {
        title: '课程时间',
        name: 'date',
        formItem: {
          type: "date~",
          showTime: true,
          rules: [{
            required: true,
            message: '请选择课程时间'
          }],
          onChange: (form, value) => {
            this.setState({
              startDate: value && value.length > 0 ? value[0].format('YYYY-MM-DD HH:mm:ss') : "",
              endDate: value && value.length > 0 ? value[1].format('YYYY-MM-DD HH:mm:ss') : "",
            })
          },
          initialValue: initialDate
        },
      },

      {
        title: "讲师",
        name: "lectures",
        dataIndex: "lectures",
        formItem: {
          ...userConfig,
          rules: [
            {
              validator: this.lecturesValidator,
            }
          ],
          placeholder: '请选择讲师',
          title: '选择讲师',
          diy: WizTableForm,
          initialValue: this.initialValue.lectures ? this.initialValue.lectures : [],
          initRows: this.initialValue.personInfo ? this.initialValue.personInfo : [],
          onClearWiz: this._onClearWiz.bind(this),
          rowKey: 'personId',
          rowName: 'fullName'
        },
      },
      {
        title: "上传封面",
        name: "imgOne",
        dataIndex: "imgOne",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            record = initialValue;
            const { getFieldDecorator } = form;
            let imgOne = null;
            let fileName = null;
            let fileMimeType = null;
            let fileSize = null;
            let fileUri = null;
            if (record != null && record.imgOne != null && record.imgOne != null) {
              imgOne = record.imgOne;
              fileName = record.fileName;
              fileMimeType = record.fileMimeType;
              fileSize = record.fileSize;
              fileUri = record.fileUri;
            }
            console.log(record.imgOne, 'record.imgOne')

            return (
              <div>
                {
                  getFieldDecorator('imgOne', {
                    initialValue:
                      (record && record.imgOne) ? [
                        { fileId: record.imgOne }
                      ] : []
                  })(
                    <WizAvatarUpload
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={400 / 207}
                      beforeUpload={(file) => {
                        let result = true;
                        const isLt1M = file.size / 1024 / 1024 < 1
                        if (file.type.indexOf('image/') == -1) {
                          Wizmessage.error('只能上传图片类型,请重新选择!');
                          result = false;
                        } else if (!isLt1M) {
                          Wizmessage.error('图片不得超过1MB!');
                          result = false;
                        }
                        return result;
                      }}
                    />
                  )
                }
              </div>)
          }
        }
      },
      // {
      //   title: "介绍",
      //   name: "intro",
      //   dataIndex: "intro",
      //   formItem: {
      //     type: 'textarea',
      //     placeholder: '介绍最多输入100个字符',
      //     maxlength: 100,
      //     rules: [],
      //     initialValue: initialValue.intro
      //   },
      // },
      {
        title: '介绍',
        name: 'intro',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {/* {getFieldDecorator('intro', {
                  initialValue:  this.initialValue.intro && this.initialValue.intro,
                })(
                  // <div className="editor-wrapper">
                    <WizBraftEditorPlus placeholder='请输入介绍' links={[0,1,2,3]}
                    // onChange={(e) => {
                    //   this.handleChange(e)
                    // }}
                   value={this.initialValue.intro ? this.initialValue.intro : null}  />
                  // </div>
                )} */}
                {getFieldDecorator('intro', {
                  initialValue: intro && intro,
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} />
                )}
              </>
            )
          }
        },
      },
      //高级设置
      {
        title: "学习限制",
        name: "limit",
        dataIndex: "limit",
        formItem: {
          type: 'diy',
          diy: ProgramLimit,
          rules: [],
          initialValue: initialValue.limit
        },
      },

      {
        title: "分享至微信",
        name: "shareWay_wechat",
        dataIndex: "shareWay_wechat",
        formItem: {
          type: 'checkbox',
          dict: [{ codeName: '', code: 1 }],
          rules: [],
          initialValue: initialValue.shareWay_wechat,
        },
      },

      {
        title: "分享至同事圈",
        name: "shareWay_community",
        dataIndex: "shareWay_community",
        formItem: {
          type: 'checkbox',
          dict: [{ codeName: '', code: 1 }],
          rules: [],
          initialValue: initialValue.shareWay_community
        },
      },
    ]

    let onSubmit = this._saveProgram.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 }//15
      },
      style: { maxWidth: '100%', width: '100%' }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }

    return (
      <Spin tip={'加载中'} spinning={programLoading || programEntityLoading}>

        <WizCustomSteps {...wizCustomStepsProps} />

        {this.codeModal()}
        {this.scheduleListModal()}
        {this.examListModal()}
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { program, programEntity, questionType, personManage } = state;
  const saveProgram = modelUtils.getModelEntity(program, "saveProgram");
  const addProgram = modelUtils.getModelEntity(program, "addProgram");
  const saveContent = modelUtils.getModelEntity(programEntity, "saveContent");
  const getProgramEntityList = modelUtils.getModelEntity(programEntity, "getProgramEntityList");
  const load = modelUtils.getLoadingState(state, ['program', 'programEntity']);
  const treeData = modelUtils.getModelEntity(questionType, "questionType@treeData");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const authInfo = modelUtils.getModelEntity(program, "programAuthInfo");
  const saveAuthKey = modelUtils.getModelEntity(program, "programSaveAuthKey");
  const programInfo = modelUtils.getModelEntity(program, "getProgramById");
  return {
    addProgram: addProgram,
    saveProgram: saveProgram,
    saveContent: saveContent,
    getProgramEntityList: getProgramEntityList,
    treeData,
    personInfo: personInfo,
    authInfo,
    saveAuthKey,
    programInfo: programInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ProgramDetail);
